import { Component, type ErrorInfo, type ReactNode } from "react";

import { errors } from "../services/errors/errors";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class AppErrorBoundary extends Component<Props, State> {
  public state: State = { failed: false };

  public static getDerivedStateFromError(): State {
    return { failed: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    errors.capture(error, {
      componentStackPresent: Boolean(info.componentStack),
    });
  }

  public render(): ReactNode {
    if (this.state.failed) {
      return (
        <main className="fatal-error">
          <span className="eyebrow">TRAFFIC CONTROL</span>
          <h1>The road hit an unexpected closure.</h1>
          <p>Your browser is fine. This lane of the internet needs a reload.</p>
          <button
            className="button button--primary"
            type="button"
            onClick={() => location.reload()}
          >
            Reload the road
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
